import { createManager } from "@magnit/core/src/components/VToast/VToastManager";

export default defineNuxtPlugin(() => {
  return {
    provide: {
      toast: createManager(),
    },
  };
});
